import React from 'react';
import BBDataTable from "../tables/BBDataTable";
import {bbFormattedDateString, mapObject} from "../../../util/bbHelpers";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";

const BRSocialTestEventsTable = ({events=[]})=>{


    const eventsArray = events && events.map((event)=>{

        let eventType;

        if(event.opened_datetime){
            eventType = "Opened"
        } else if(event.execution_type){
            eventType = event.execution_type.name
        } else{
            eventType = null;
        }

        return{
            ...event,
            eventDateTime: event.opened_datetime || event.execution_datetime,
            eventType: eventType,


        }
    })


    const columns=[
        { field: "id", headerName: "ID", hide: true, flex: 1, sortable: false, renderCell: (params)=>
                renderCellExpand(params, (
                    <span>
               {params.value}
           </span>
                ))},
        { field: "eventDateTime", headerName: "Event Date", hide: false, flex: 1, sortable: false, renderCell: (params)=>
                renderCellExpand(params, (
                    <span>
               {bbFormattedDateString(params.value, "shortFullMonth")}
           </span>
                ))},
        { field: "source_ip", headerName: "Source IP", hide: false, sortable: false, flex: 1, renderCell: (params)=>
                renderCellExpand(params, (
                    <code>
               {params.value}
           </code>
                ))},
        { field: "eventType", headerName: "Type", hide: false, sortable: false, flex: 1, renderCell: (params)=>
                renderCellExpand(params, (
                    <span>
                        {params.value}
                    </span>
                ))},
        ]

    return(
        <div>
            {eventsArray ?
                <BBDataTable
                    columns={columns}
                    rows={eventsArray}
                    totalRows={events.length}
                    title={null}
                    loading={false}
                    rowsPerPageOptions = {[3, 10, 25, 50, 100]}
                    defaultPageSize = {5}
                    disableColumnSelector
                    disableDensitySelector
                    disableColumnMenu
                    disableColumnFilter
                />
                :
                <BBDataTable
                    columns={columns}
                    rows={[]}
                    title={null}
                    loading={true}
                    progressValue={0}
                    rowsPerPageOptions = {[3, 10, 25, 50, 100]}
                    defaultPageSize = {5}
                    disableColumnSelector
                    disableDensitySelector
                    disableColumnMenu
                    disableColumnFilter
                />
            }
        </div>
    )

}

export default BRSocialTestEventsTable;